var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBroadcast02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6426 11.3923C36.5184 14.3659 38.2996 18.4712 38.2996 22.9987C38.2996 27.5274 36.5174 31.6338 33.6402 34.6075",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1301 39.25C42.1577 35.0869 44.6523 29.3383 44.6523 22.9986C44.6523 16.6602 42.1587 10.9127 38.1326 6.74976",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.86501 6.7522C3.84028 10.9149 1.34766 16.6614 1.34766 22.9986C1.34766 29.3369 3.84127 35.0845 7.86744 39.2474",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3574 34.6049C9.48156 31.6314 7.70041 27.526 7.70041 22.9985C7.70041 18.4724 9.48057 14.3681 12.3549 11.3948",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8474 29.9624C15.1219 28.1783 14.0532 25.7151 14.0532 22.9986C14.0532 20.2835 15.1209 17.8213 16.845 16.0374",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1527 16.0349C30.8781 17.819 31.9468 20.2823 31.9468 22.9987C31.9468 25.7164 30.8772 28.1806 29.1502 29.965",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 25.6953C24.4692 25.6953 25.6602 24.4886 25.6602 23C25.6602 21.5114 24.4692 20.3047 23 20.3047C21.5308 20.3047 20.3398 21.5114 20.3398 23C20.3398 24.4886 21.5308 25.6953 23 25.6953Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcast02);
export default __webpack_public_path__ + "static/media/Broadcast02.bdb88931f7855ddc8fc57cd800df43b3.svg";
export { ForwardRef as ReactComponent };